<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#"></b-link>

    <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>

    <b-navbar-nav class="ml-auto">
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <i class="fa fa-user fa-lg"></i>
        </template>
        <b-dropdown-header tag="div" class="text-center"><strong>Account - {{account_num}}</strong></b-dropdown-header>
        <b-dropdown-item @click="userLogout"><i class="fa fa-lock"></i> Logout <strong><i class="mx-2">{{user_name}}</i></strong></b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

  </header>
</template>
<script>
import Vue from 'vue'
import router from '@/router'
import VueCookies from 'vue-cookies'
import tokenexpiration from '@/shared/tokenexpiration'

Vue.use(VueCookies)

export default {
  name: 'c-header',
  created () {
    tokenexpiration.setCookiesTime(this)
  },
  data () {
    return {
      account_num: localStorage.getItem('account'),
      user_name: localStorage.getItem('login'),
      expTime: tokenexpiration.getTimeoutMinutes()
    }
  },
  beforeDestroy () {
    tokenexpiration.beforeDestroy(this)
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    userLogout () {
      this.removeLocalStorage()
      router.push('/logout')
    },
    goToMyProfile () {
      router.push('/MyProfile')
    },
    removeLocalStorage () {
      localStorage.removeItem('selectedVinNumber')
      localStorage.removeItem('selectedMileage')
      localStorage.removeItem('customerZip')
      localStorage.removeItem('dealerZip')
      localStorage.removeItem('selectedTerms')
      localStorage.removeItem('cash')

      localStorage.removeItem('inventoryVehicleIsNew')
      localStorage.removeItem('inventoryVehicleMake')
      localStorage.removeItem('inventoryVehicleModel')
      localStorage.removeItem('inventoryVehicleYear')
      localStorage.removeItem('inventoryVehicleTrim')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue